import { render, staticRenderFns } from "./avalonSelectField.vue?vue&type=template&id=3c237336&scoped=true&"
import script from "./avalonSelectField.vue?vue&type=script&lang=js&"
export * from "./avalonSelectField.vue?vue&type=script&lang=js&"
import style0 from "./avalonSelectField.vue?vue&type=style&index=0&id=3c237336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c237336",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VHover,VIcon,VMenu,VSheet})
